@import 'styles/mixins';

.container {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  overflow: hidden;
}
.buttonContainer {
  width: 100%;
  display: flex;
  justify-content: flex-start;
}

.cardContainer {
  opacity: 1;
  z-index: 2;
}

@include for-phone-only {
  .container {
    padding-bottom: 20px;
  }
}
